import {
    addFdListener,
    FreezeDryItemTypes,
    EventTypes,
    lazyCreateOrUpdateMainWindowItem,
} from 'owa-freeze-dry';
import { createMainWindowItem } from './createMainWindowItem';
import { logGreyError } from 'owa-analytics';
import { type MainWindow } from 'owa-freeze-dry';

function handlePersistScrollPosition() {
    try {
        const mainWindow: Partial<MainWindow> = createMainWindowItem();
        if (mainWindow) {
            lazyCreateOrUpdateMainWindowItem.importAndExecute(mainWindow);
        } else {
            /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
             * BASELINE: DO NOT COPY/PASTE!
             *	> Argument at index 1 for logGreyError must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
            logGreyError('FreezeDryPersistScrollPositionError_MainWindowUndefined', undefined);
        }
    } catch (e) {
        /* eslint-disable owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
         * BASELINE: DO NOT COPY/PASTE!
         *	> Argument at index 1 for logGreyError must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
        // Errors resulting from enabling useUnknownInCatchVariables
        // TS2345: Argument of type 'unknown' is not assignable to parameter of type 'Error | undefined'.
        // @ts-expect-error
        logGreyError('FreezeDryPersistScrollPositionError', undefined, e);
        /* eslint-enable owa-custom-rules/telemetry-mailboxinfo-as-second-param */
    }
}

// Add the listener to 'fdEventManager'
export function initializePersistMailListener(): void {
    addFdListener(EventTypes.Persist, FreezeDryItemTypes.MainWindow, handlePersistScrollPosition);
}
